export default {
  gutter: Number,

  grids: Number,

  labelWidth: Number,

  labelAlign: String,

  itemHeight: Number,
}
